/* eslint-disable jsx-a11y/anchor-is-valid */
import DarkMode from "./DarkMode";
import { useState, useContext } from "react";
import MobileNavBar from "./MobileNavBar";
import { motion, MotionConfig } from 'framer-motion';
import { ThemeContext } from "./context/ThemeContext";

const Header = () => {

    const [active, setActive] = useState(false)
    const [open, setOpen] = useState(false)
    const { darkMode } = useContext(ThemeContext);

    return (
        <header className="">
            <nav className={`flex flex-row justify-between items-center p-2 lg:p-4 fixed lg:top-2 z-50 lg:right-2 lg:left-2 left-0 right-0 top-0  lg:border-[0.2px] shadow-2xl lg:rounded-full backdrop-blur sm:mb-4 ${darkMode ? " text-white border-white" : "text-black border-black"}`}>
                <DarkMode />
                <ul className="flex-row items-center justify-center gap-8 text-xl hidden lg:flex mr-20">
                    <a href='#home'>Home</a>
                    <a href='#about'>About</a>
                    <a href='#works'>Works</a>
                    <a href='#contact'>Contact</a>
                </ul>

                <MotionConfig>
                    <motion.button initial={false} onClick={() => { setActive(!active); setOpen(!open) }} className={`${darkMode ? "bg-black border-white border" : "border-black border bg-white"} relative h-10 w-10 rounded  lg:hidden flex items-center justify-center`} animate={active ? 'open' : 'closed'}>
                        <motion.span style={{
                            left: '50%',
                            top: '35%',
                            x: '-50%',
                            y: '-50%',
                        }} variants={{
                            open: {
                                rotate: '45deg',
                                top: ['35%', '50%', "50%"]
                            },
                            closed: {
                                rotate: "0deg"
                            }
                        }} className={`absolute h-0.5 w-5 ${darkMode ? "bg-white" : "bg-black"}`} />
                        <motion.span style={{
                            left: '50%',
                            top: '50%',
                            x: '-50%',
                            y: '-50%',
                        }} className={`absolute h-0.5 w-5 ${darkMode ? "bg-white" : "bg-black"}`}
                            variants={{
                                open: {
                                    rotate: '-45deg',

                                },
                                closed: {
                                    rotate: "0deg"
                                }
                            }}
                        />
                        <motion.span style={{
                            left: 'calc(50% + 4px)',
                            bottom: '35%',
                            x: '-50%',
                            y: '50%',
                        }} variants={{
                            open: {
                                rotate: '45deg',
                                left: '50%',
                                bottom: ['35%', '50%', '50%']

                            },
                            closed: {
                                rotate: "0deg",
                                left: 'calc(50% + 4px)',

                            }
                        }} className={`absolute h-0.5 w-3 ${darkMode ? "bg-white" : "bg-black"}`} />
                    </motion.button>
                </MotionConfig>
            </nav>

            {open && <MobileNavBar />}
        </header>
    );
}

export default Header;